module.exports = __webpack_public_path__ + "img/左边.af674866.png";